module.exports = __webpack_public_path__ + "static/media/29EUNOG14.98b7c8be.jpg";